import React, { useEffect, useRef, useState } from 'react';
import { Col, notification, Row, Select } from 'antd';
import { useGlobalState } from './GlobalState';
import SelectLake from './SelectLake';
import 'react-multi-carousel/lib/styles.css';
import axios from 'axios';
import moment from 'moment-timezone';
import CryptoJS from 'crypto-js';
import BookingDetails from '../assets/images/BookingDetails.png';
import selectLake from '../assets/images/SelectLake.png';
import packageList from '../assets/images/package-list.svg';
import { exotic_fishery } from '../../common/Utils';
import { useHistory } from 'react-router-dom';
import { toUTCDate } from '../../../utils/date';
import { emptyDatesObject } from '../../availability_calendar/AvailabilityCalendar';
import SelectedInfoPanel from '../../common/SelectedInfoPanel';
import SvgEdit from '../../../assets/images/Icons/SVG/Edit';
import { useUserIdentification } from '../../../utils/hooks';
import { useGetDynamicBookingTextQuery } from '../../user_profile/userProfileSlice';

const { Option } = Select;

export default function SelectLakeAndTickets(props) {
  const history = useHistory();

  const is_exotic_fishery = props.fishery_id === exotic_fishery;
  const { data: DynamicText } = useGetDynamicBookingTextQuery(props.fishery_id);
  const is_manor = props.fishery_id === process.env.REACT_APP_FISHERY_MANOR_ID;
  const is_woolpack = +props.fishery_id === 10832;
  const [userSelectedAnglers, setUserSelectedAnglers] = useGlobalState(
    'userSelectedAnglers'
  );
  const [userSelectedLakeName] = useGlobalState('userSelectedLakeName');
  const [lakeExclusive, setLakeExclusive] = useGlobalState('lakeExclusive');
  const [isLakeExclusive, setIsLakeExclusive] =
    useGlobalState('isLakeExclusive');
  const [userSelectedRods, setUserSelectedRods] =
    useGlobalState('userSelectedRods');
  const [userSelectedLakeId, setUserSelectedLakeId] =
    useGlobalState('userSelectedLakeId');
  const [userSelectedPakage, setUserSelectedPakage] =
    useGlobalState('userSelectedPakage');
  const [, setBookingsLoading] = useGlobalState('bookingsLoading');
  const [lakeInfo] = useGlobalState('lakeInfo');
  const [, setDisabledDates] = useGlobalState('disabledDates');
  const [, setLimitedDates] = useGlobalState('limitedDates');
  const [, setLakeInfo] = useGlobalState('lakeInfo');
  const [, setFisheryInfo] = useGlobalState('fisheryInfo');
  const [isInsideWidget] = useGlobalState('isInsideWidget');

  const [, setUserBookingData] = useGlobalState('userBookingData');
  const [, setUserSelectedSwims] = useGlobalState('userSelectedSwims');
  const [, setUserSelectedDoubleSwim] = useGlobalState(
    'userSelectedDoubleSwim'
  );

  const [, setAvailableTime] = useGlobalState('availableTime');
  const [, setBookingDates] = useGlobalState('bookingDates');
  const [lakeDetails, setLakeDetails] = useGlobalState('lakeDetails');

  const [, setArrivalTime] = useGlobalState('arrivalTime');
  const [, setDepartureTime] = useGlobalState('departureTime');
  const [, setEstimatedPricing] = useGlobalState('estimatedPricing');

  const [, setLoading] = useState(true);
  const [guestAllowed] = useGlobalState('guestAllowed');
  const [lakeType, setLakeType] = useGlobalState('lakeType');
  const [ticketAvailable, setTicketAvailable] =
    useGlobalState('ticketsAvailable');
  const [maxGuestPerAngler, setMaxGuestPerAngler] = useState(
    lakeDetails?.guest_limit_per_angler ?? 0
  );
  const [guestOptions, setGuestOptions] = useState([]);
  const [accommodation] = useGlobalState('accommodation');
  const [loginChecked, setLoginChecked] = React.useState(false);

  const detailsRef = useRef();

  const [bookingType, setBookingType] = useGlobalState('bookingType');
  const is_exotic_arapaima_lake =
    userSelectedLakeId === 'a4688274-3f67-40a5-be8d-a8dc51c053b3';
  const handleBookingTypeChange = (value) => {
    setBookingType(value);

    if (value === 'lake_exclusive') {
      handleLakeExclusiveCheckboxChanged(true, value);
    } else {
      handleLakeExclusiveCheckboxChanged(false, value);
    }
  };
  const ADHfishery = 11797;
  const SapphireFishery = 10525;

  const getBookingsInfo = (
    lake_id,
    anglers,
    exclusive,
    bookingType,
    packageId = null
  ) => {
    // Reset timing
    // setAvailableTime(null);
    // setArrivalTime(null);
    // setDepartureTime(null);
    //

    setBookingsLoading(true);
    const axios_config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };

    let payload_data = {
      anglers: anglers,
      guest: userSelectedRods,
      lake_id: lake_id,
      date: moment(new Date()).format('YYYY-MM-DD'),
      book_lake_exclusive: exclusive,
      ...(packageId ? { custom_slot_id: packageId } : {}),
      booking_type: bookingType,
    };

    axios
      .post('booking/lake/details', payload_data, axios_config)
      .then((res) => {
        if (res.status === 200) {
          const _result = res.data.result;
          setDisabledDates(_result.fully_booked_dates.map(toUTCDate));
          setLimitedDates(
            _result?.limited_availability_dates?.map((ld) => ({
              ...ld,
              date: toUTCDate(ld.date),
            })) || []
          );
          setLakeDetails(_result);
          setIsLakeExclusive(_result?.lake_exclusive_enabled);
          setLakeType(_result.lake_type);

          setTicketAvailable(_result.swims_tickets_available);
          setMaxGuestPerAngler(_result.guest_limit_per_angler);
        } else {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Error processing result',
          });
        }
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          if (err.response.status === 500) {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description: 'Server Response failed. Please try again later',
            });
          } else if (err.response.status === 401) {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description:
                'Your action will not be saved. Please Login and try again!',
            });
          } else if (err.response.status === 400) {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description: err.response.data['detail'],
            });
          } else if (err.response.status === 422) {
            if (err.response.data['detail'] === 'Signature has expired') {
              notification.error({
                message: <div className='gSemiBold'>There was an issue!</div>,
                style: { border: '1px #D34545 solid' },
                placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
                className: 'gRegular br10',
                description:
                  'Login session has been expired. Please Login to continue!',
              });
            } else {
              notification.error({
                message: <div className='gSemiBold'>There was an issue!</div>,
                style: { border: '1px #D34545 solid' },
                placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
                className: 'gRegular br10',
                description:
                  "OOPS! Server didn't like the request. If this persists please contact support team",
              });
            }
          } else if (err.response.status === 423) {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description:
                'Sorry ! this booking slot has been booked by another user, Try different booking!',
            });
          }
        } else {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Error processing result',
          });
        }
      })
      .finally(() => {
        setBookingsLoading(false);
        setLoading(false);
      });
  };

  const handleAnglerChange = (value) => {
    setUserSelectedAnglers(value);
    setUserBookingData({});
    setUserSelectedSwims([]);
    setUserSelectedDoubleSwim([]);
    setEstimatedPricing(null);

    setUserSelectedLakeId(userSelectedLakeId);

    userSelectedLakeId &&
      getBookingsInfo(
        userSelectedLakeId,
        value,
        false,
        bookingType,
        lakeDetails?.custom_slot_days &&
          lakeDetails?.custom_slot_days[userSelectedPakage - 1]?.id
      );

    // Reset Form
    setAvailableTime(null);
    setLakeExclusive(false);
    // setUserSelectedSwims(null);
    // setUserSelectedLakeId(null);
    setBookingDates([{ ...emptyDatesObject }]);
    setArrivalTime(null);
    setDepartureTime(null);
  };

  const handleRodChange = (value) => {
    setUserSelectedRods(value);
    setLakeExclusive(false);
  };

  const generateNumAnglersList = (maxAngler) => {
    const isManorFishing = is_manor && !accommodation;
    const maximumAngler = isManorFishing || is_woolpack ? 1 : maxAngler;
    let list = [];
    for (let i = 1; i <= maximumAngler; i++) {
      list.push(i);
    }
    return list;
  };

  useEffect(() => {
    const MaxGuest = userSelectedAnglers * maxGuestPerAngler;
    const list = [];
    for (let i = 0; i <= MaxGuest; i++) {
      list.push(i);
    }
    setGuestOptions(list);
  }, [maxGuestPerAngler, userSelectedAnglers]);

  const { resetIdentity } = useUserIdentification();
  const logOutUser = () => {
    const axios_config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };

    axios
      .get('/angler/refresh-revoke', axios_config)
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        axios
          .get('/angler/access-revoke', axios_config)
          .then(() => {
            resetIdentity();
          })
          .catch(() => {})
          .finally(() => window?.location?.reload?.());
      });
  };

  const getBookingInfo = () => {
    let getParams = { fishery_id: props.fishery_id };

    const axios_config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      withCredentials: true,
      params: getParams,
    };

    axios
      .get('booking/details', axios_config)
      .then((res) => {
        if (res.status === 200) {
          let _result = res.data.result;
          if (_result.lakes.length > 0) {
            setLakeInfo(_result.lakes);
            setFisheryInfo(_result.fishery_info);
          }
          setLoading(false);
        } else {
          console.error(res);
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Error processing request',
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          if (
            err.response.status === 401 ||
            (err.response.status === 422 &&
              err.response.data.detail === 'Signature has expired')
          ) {
            if (
              err.response.data.detail === 'Signature has expired' &&
              isInsideWidget
            ) {
              logOutUser();
            } else {
              notification.error({
                message: <div className='gSemiBold'>There was an issue!</div>,
                style: { border: '1px #D34545 solid' },
                placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
                className: 'gRegular br10',
                description: 'Please login to continue',
              });
              history.push(`/fishery/${props.fishery_id}`);
            }
          }
        } else {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Error processing result',
          });
        }
        setLoading(false);
      });
  };

  const logUser = (username, password) => {
    const instance = axios.create({
      withCredentials: true,
      crossDomain: true,
      baseURL: `${process.env.REACT_APP_AXIOS_URL}`,
      'Access-Control-Allow-Origin': '*',
      sameSite: null,
      secure: false,
    });

    const config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);

    instance
      .post('login', formData, config)
      .then((res) => {
        if (res.status === 200) {
          window.location.reload(true);
        } else {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Incorrect Details. Please try again.',
          });
        }
      })
      .catch((err) => {
        notification.error({
          message: <div className='gSemiBold'>There was an issue!</div>,
          style: { border: '1px #D34545 solid' },
          placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
          className: 'gRegular br10',
          description: 'Incorrect Details. Please try again.',
        });
        if (err.response) {
          if (err.response.status !== 401 && err.response.status !== 200) {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description: 'Incorrect Details. Please try again.',
            });
          }
        }
      })
      .finally(() => {});
  };

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    window.scrollTo(0, 0);
    // Update the document title using the browser API
    if (loginChecked) {
      getBookingInfo();
    }
  }, [loginChecked]);

  useEffect(() => {
    if (lakeDetails.lake_exclusive_only) {
      setLakeExclusive(true);
    }
  }, [lakeDetails]);

  const handlePackage = (value) => {
    const isExclusive =
      lakeDetails?.custom_slot_days[value - 1]?.booking_type ===
      'lake_exclusive';
    setLakeExclusive(isExclusive);

    getBookingsInfo(
      userSelectedLakeId,
      userSelectedAnglers,
      isExclusive,
      bookingType,
      lakeDetails?.custom_slot_days[value - 1]?.id
    );
    setBookingDates([{ ...emptyDatesObject }]);

    setUserSelectedPakage(value);
    setUserSelectedAnglers(1);
    setUserSelectedRods(0);

    setEstimatedPricing(null);
    setAvailableTime(null);
    setArrivalTime(null);
    setDepartureTime(null);
  };

  useEffect(() => {
    if (window) {
      const search = window.location.search;
      const params = new URLSearchParams(search);
      const paramData = params.get('details');

      if (paramData) {
        const cryptkey = CryptoJS.enc.Utf8.parse(
          process.env.REACT_APP_PRIVATE_KEY
        );
        const cryptiv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV);

        // Decryption
        const crypted = CryptoJS.enc.Base64.parse(
          decodeURIComponent(paramData.toString())
        );
        var decrypt = CryptoJS.AES.decrypt({ ciphertext: crypted }, cryptkey, {
          iv: cryptiv,
          mode: CryptoJS.mode.CTR,
        });
        const decryptedValue = decrypt.toString(CryptoJS.enc.Utf8).split(':');

        const axios_config = {
          headers: {
            Accept: 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        };

        if (decryptedValue.length === 2) {
          axios
            .get('auth', axios_config)
            .then((res) => {
              if (res.status === 200) {
                setLoginChecked(true);
              } else {
                logUser(decryptedValue[0], decryptedValue[1]);
              }
            })
            .catch(() => {
              logUser(decryptedValue[0], decryptedValue[1]);
            });
        }
      } else {
        setLoginChecked(true);
      }
    }
  }, []);

  const disableNonLakeExclusiveControls = isLakeExclusive && lakeExclusive;

  const ticketTypeName =
    (is_exotic_fishery && !is_exotic_arapaima_lake) || accommodation
      ? 'Guests'
      : lakeType.toLowerCase() === 'ticket'
        ? 'Tickets'
        : 'Anglers';

  const anglersControl = (
    <>
      <p className='booking-control__label'>
        {`Total No. of  ${ticketTypeName}: `}
      </p>
      <Select
        className='booking-control__select'
        onChange={handleAnglerChange}
        disabled={disableNonLakeExclusiveControls}
        defaultValue={userSelectedAnglers ? userSelectedAnglers : 1}
        value={userSelectedAnglers}
        virtual={false}
      >
        {generateNumAnglersList(ticketAvailable).map((id) => {
          return (
            <Option className='gLight' value={id}>
              {id}
            </Option>
          );
        })}
      </Select>
    </>
  );

  const bookingTypeControl = (
    <>
      <p className='booking-control__label'>Choose Your Booking Type:</p>
      <Select
        className='booking-control__select'
        onChange={handleBookingTypeChange}
        virtual={false}
        value={bookingType}
        dropdownMatchSelectWidth={false}
      >
        <Option className='gLight' value='ticket'>
          {SapphireFishery === +props.fishery_id
            ? 'Ticket (Single Swims)'
            : ADHfishery === +props.fishery_id
              ? 'Watercraft Tickets'
              : 'Tickets'}
        </Option>
        <Option className='gLight' value='swim'>
          {SapphireFishery === +props.fishery_id
            ? 'Double Swims'
            : ADHfishery === +props.fishery_id
              ? 'Cabin'
              : 'Swims'}
        </Option>
        {lakeDetails?.lake_exclusive_enabled && (
          <Option className='gLight' value='lake_exclusive'>
            Lake Exclusive
          </Option>
        )}
      </Select>
    </>
  );

  const handleLakeExclusiveCheckboxChanged = (
    checked,
    userSelectedBookingType = bookingType
  ) => {
    const selectedPackageIsExclusive =
      lakeDetails?.custom_slot_booking && lakeExclusive;
    if (lakeDetails.lake_exclusive_only || selectedPackageIsExclusive) {
      return;
    }
    setUserSelectedAnglers(1);
    setUserSelectedRods(0);
    setLakeExclusive(checked);
    userSelectedLakeId &&
      getBookingsInfo(
        userSelectedLakeId,
        1,
        checked,
        userSelectedBookingType,
        lakeDetails?.custom_slot_days &&
          lakeDetails?.custom_slot_days[userSelectedPakage - 1]?.id
      );
    // Reset Form
    setAvailableTime(null);
    setBookingDates([{ ...emptyDatesObject }]);
    setArrivalTime(null);
    setDepartureTime(null);
    setEstimatedPricing(null);
  };

  const zeroGuests =
    !guestOptions?.length ||
    (guestOptions.length === 1 && guestOptions[0] === 0);

  const guestsControl = guestAllowed !== 'no' && !zeroGuests && (
    <>
      <p className='booking-control__label'>
        {is_exotic_fishery && !is_exotic_arapaima_lake
          ? 'How many Guests will be fishing?:'
          : ' Non-Angling Guests:'}
      </p>
      <Select
        className='booking-control__select'
        disabled={guestAllowed === 'no' || disableNonLakeExclusiveControls}
        defaultValue={userSelectedRods ? userSelectedRods : 0}
        onChange={handleRodChange}
        value={userSelectedRods}
        virtual={false}
      >
        {guestOptions.map((id) => {
          return (
            <Option className='gLight' value={id}>
              {id}
            </Option>
          );
        })}
      </Select>
    </>
  );

  const customPackageControl = (
    <>
      <p className='booking-control__label'>Choose Your Package:</p>
      <Select
        className='booking-control__select'
        onChange={handlePackage}
        value={userSelectedPakage}
        virtual={false}
        dropdownMatchSelectWidth={false}
      >
        {lakeDetails?.custom_slot_days?.map((option, i) => (
          <Select.Option value={i + 1} key={i}>
            {option?.name}
          </Select.Option>
        ))}
      </Select>
    </>
  );

  const lakeExclusiveControl = (
    <div className='booking-controls--stacked '>
      <p className='booking-control__label'>
        <p className={'mg-bottom-0'}>Book Lake Exclusive </p>
        <p className='gLight fs-14 mg-bottom-0'>
          {`(Up To ${
            lakeDetails?.lake_exclusive_anglers_allowed ?? '10'
          }  Anglers Allowed)`}
        </p>
      </p>
      <Col className='booking-control__select booking-control__select--checkbox_only'>
        <input
          type='checkbox'
          checked={lakeExclusive}
          onChange={(e) => {
            handleLakeExclusiveCheckboxChanged(e.target.checked);
          }}
          style={{ width: '30px', height: '30px' }}
        />
      </Col>
    </div>
  );

  const accomodationControl = (
    <div className='booking-controls--stacked '>
      <p className='booking-control__label'>
        <p className={'mg-bottom-0'}>Book Accommodation </p>
        <p className='gLight fs-14 mg-bottom-0'>
          {`(Up To ${
            lakeDetails?.lake_exclusive_anglers_allowed ?? '10'
          }  Guests Allowed)`}
        </p>
      </p>
      <Col className='booking-control__select booking-control__select--checkbox_only'>
        <input
          type='checkbox'
          checked={lakeExclusive}
          onChange={(e) => {
            handleLakeExclusiveCheckboxChanged(e.target.checked);
          }}
          style={{ width: '30px', height: '30px' }}
        />
      </Col>
    </div>
  );

  console.log(accommodation, lakeExclusive);

  return (
    <div>
      <h1 className='fs-27 gBold black'>
        {is_exotic_fishery
          ? 'Great! Let’s book your Exotic Fishing package.'
          : 'Great! Let’s begin your booking session.'}
      </h1>
      <Row>
        <Col span={24}>
          <Col span={24} className='booking-session-heading h-40'>
            <img
              src={selectLake}
              alt={'Location icon'}
              style={{
                width: '16px',
                'vertical-align': 'sub',
              }}
            />
            <span className='white fs-16 pd-left-10 pd-2'>
              {is_exotic_fishery
                ? 'Please select your package below'
                : lakeInfo?.filter((lake) => lake.accommodation).length > 0
                  ? 'Please select your lake or accommodation'
                  : DynamicText?.is_active &&
                      DynamicText?.properties?.booking_step_1
                        ?.lake_selection_prompt
                    ? DynamicText?.properties?.booking_step_1
                        ?.lake_selection_prompt
                    : 'Please select your lake'}
            </span>
          </Col>
          <Row>
            <Col span={24}>
              <div id='booking-lake-select' className=' mg-top-30 mg-bottom-30'>
                <SelectLake
                  fishery_id={props.fishery_id}
                  setMaxGuestPerAngler={setMaxGuestPerAngler}
                  scrollToRef={detailsRef}
                  disabled={props?.disabled}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <div style={{ position: 'relative' }}>
        <Col span={24} className='booking-session-heading h-40'>
          <img
            src={BookingDetails}
            alt={'Booking details icon'}
            style={{
              width: '16px',
              verticalAlign: 'sub',
            }}
          />
          <span ref={detailsRef} className='white fs-16 pd-left-10 pd-2'>
            {is_exotic_fishery
              ? 'Please select the total number of guests in your party'
              : 'Enter your booking details'}
          </span>
        </Col>
        {!userSelectedLakeId && (
          <div className='booking-overlay'>
            <div className='overlay-content gSemiBold'>
              Select your lake first
            </div>
          </div>
        )}

        <div className='mg-top-30 mg-bottom-30'>
          {lakeDetails?.lake_type === 'Swim-Ticket' ? (
            <>
              <div className='booking-controls--stacked '>
                {bookingTypeControl}
                {bookingType === 'lake_exclusive' && !accommodation && (
                  <>{lakeExclusiveControl}</>
                )}
                {lakeExclusive && accommodation && <>{accomodationControl}</>}
                {(bookingType === 'swim' || bookingType === 'ticket') && (
                  <>
                    <p className='booking-control__label'>
                      {is_exotic_fishery || accommodation
                        ? 'Total Number of Guests'
                        : `Total No. of  ${ticketTypeName}: `}
                    </p>
                    <Select
                      className='booking-control__select'
                      onChange={handleAnglerChange}
                      disabled={disableNonLakeExclusiveControls}
                      defaultValue={
                        userSelectedAnglers ? userSelectedAnglers : 1
                      }
                      value={userSelectedAnglers}
                      virtual={false}
                    >
                      {generateNumAnglersList(ticketAvailable).map((id) => {
                        return (
                          <Option className='gLight' value={id}>
                            {id}
                          </Option>
                        );
                      })}
                    </Select>
                    <p className='booking-control__label'>
                      {is_exotic_fishery && !is_exotic_arapaima_lake
                        ? 'How many Guests will be fishing?:'
                        : ' Non-Angling Guests:'}
                    </p>
                    <Select
                      className='booking-control__select'
                      disabled={
                        guestAllowed === 'no' || disableNonLakeExclusiveControls
                      }
                      defaultValue={userSelectedRods ? userSelectedRods : 0}
                      onChange={handleRodChange}
                      value={userSelectedRods}
                      virtual={false}
                    >
                      {guestOptions.map((id) => {
                        return (
                          <Option className='gLight' value={id}>
                            {id}
                          </Option>
                        );
                      })}
                    </Select>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              {lakeDetails?.custom_slot_booking && !userSelectedPakage ? (
                <div className='booking-controls--stacked mg-bottom-20'>
                  {customPackageControl}
                </div>
              ) : lakeDetails?.custom_slot_booking && lakeExclusive ? (
                <>
                  <div className='booking-controls--stacked mg-bottom-20'>
                    {customPackageControl}
                  </div>

                  <div>
                    <p className='booking-control__label txt-center'>
                      <p className={'mg-bottom-0'}>
                        {DynamicText?.is_active ? (
                          DynamicText?.properties?.booking_step_1
                            ?.lake_exclusive_label
                        ) : (
                          <>
                            {accommodation ? 'Accommodation' : 'Lake Exclusive'}{' '}
                            <span className='gLight'>{`(Up To ${
                              lakeDetails?.lake_exclusive_anglers_allowed ??
                              '10'
                            }  ${
                              accommodation ? 'Guests' : 'Anglers'
                            })`}</span>{' '}
                          </>
                        )}
                      </p>
                    </p>
                  </div>
                </>
              ) : !lakeDetails?.custom_slot_booking && isLakeExclusive ? (
                <div
                  className='booking-controls--side_by_side'
                  style={{
                    justifyContent: lakeDetails.lake_exclusive_only
                      ? ''
                      : 'center',
                  }}
                >
                  {!lakeDetails.lake_exclusive_only && (
                    <>
                      <div>
                        <p className='gSemiBold w-full fs-16 txt-underline'>
                          Book Ticket(s):
                        </p>
                        <div className='booking-controls--stacked '>
                          {anglersControl}
                          {guestsControl}
                        </div>
                      </div>

                      <div
                        className={
                          'booking-controls--side_by_side__divider mg-top-10'
                        }
                      >
                        <span className='gBold fs-18 pd-10'>OR</span>
                      </div>
                    </>
                  )}

                  <div>
                    <p className='gSemiBold w-full fs-16 txt-underline'>
                      Book Whole Lake:
                    </p>
                    {lakeExclusiveControl}
                  </div>
                </div>
              ) : (
                <div className='booking-controls--stacked'>
                  {lakeDetails?.custom_slot_days && customPackageControl}
                  {anglersControl}
                  {guestsControl}
                </div>
              )}
              {userSelectedPakage &&
                lakeDetails?.custom_slot_days &&
                lakeDetails?.custom_slot_days[userSelectedPakage - 1]
                  ?.description && (
                  <div className='mg-top-20'>
                    <div
                      className='fs-16 gSemiBold mg-bottom-10 row-center'
                      style={{ alignItems: 'flex-start' }}
                    >
                      <img
                        src={packageList}
                        alt='package icon'
                        className='mg-right-5 '
                      />{' '}
                      Package Description{' '}
                    </div>
                    <div className='gRegular fs-16'>
                      {
                        lakeDetails?.custom_slot_days[userSelectedPakage - 1]
                          ?.description
                      }
                    </div>
                  </div>
                )}
            </>
          )}
        </div>
        <Col span={24}>
          <SelectedInfoPanel
            title={<p className={'mg-bottom-4'}>Your Selection(s)</p>}
            className={'mg-bottom-30 mg-top-65'}
            showPlaceholder={!userSelectedLakeId}
            content={
              <div
                className={'justify-between'}
                style={{ alignItems: 'flex-end', gap: '1.5rem' }}
              >
                <span>
                  {!is_exotic_fishery && !accommodation ? 'Lake: ' : ''}
                  {userSelectedLakeName}
                </span>
                <span>
                  {lakeExclusive && accommodation
                    ? ''
                    : lakeExclusive
                      ? DynamicText?.is_active &&
                        DynamicText?.properties?.booking_step_1
                          ?.booking_summary_booking_type
                        ? DynamicText?.properties?.booking_step_1
                            ?.booking_summary_booking_type
                        : 'Lake Exclusive'
                      : `No. of ${ticketTypeName}: ${userSelectedAnglers}`}
                </span>
              </div>
            }
            placeholder='Select a Lake to Get Started'
            icon={<SvgEdit />}
            iconSize={1.5}
          />
        </Col>
      </div>
    </div>
  );
}
